import React from 'react'
import { Col, Container, Row, Image } from 'react-bootstrap'
import LeftArrow from '../../../Assets/images/cultured-img/landing-page-img/left-arrow.png'
import RightArrow from '../../../Assets/images/cultured-img/landing-page-img/right-arrow.png'

import Anniversary_ring from '../../../Assets/images/cultured-img/landing-page-img/ring-style-img/anniversary_ring.png'
import Channel_set from '../../../Assets/images/cultured-img/landing-page-img/ring-style-img/channel_set.png'
import Eternity_ring from '../../../Assets/images/cultured-img/landing-page-img/ring-style-img/eternity_ring.png'
import Infinity_ring from '../../../Assets/images/cultured-img/landing-page-img/ring-style-img/infinity_ring.png'
import Pave_ring from '../../../Assets/images/cultured-img/landing-page-img/ring-style-img/pave_ring.png'
import Stackable_ring from '../../../Assets/images/cultured-img/landing-page-img/ring-style-img/stackable_ring.png'
import Slider from "react-slick";
import { NavLink } from 'react-router-dom'




const BrowseByStyle = () => {

    const browseBystyle = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img alt='LeftArrow' src={LeftArrow} />,
        nextArrow: <img alt='RightArrow' src={RightArrow} />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const ringStyle = [
        {
            shapImage: Anniversary_ring,
            shapName: "Anniversary Ring",
            shapText: "Celebrate your anniversary or special occasion with a stunning ring this year.",
            url: "/jewelry/wedding-rings-and-bands/style=Anniversary"
        },
        {
            shapImage: Channel_set,
            shapName: "Channel Set",
            shapText: "Small diamonds set together to shine and stand out.",
            url: "/jewelry/wedding-rings-and-bands/style=Channel%20Set"

        },
        {
            shapImage: Eternity_ring,
            shapName: "Eternity Ring",
            shapText: "Commemorate your special day with rings that stay for life.",
            url: "/jewelry/wedding-rings-and-bands/style=Eternity"
        },
        {
            shapImage: Infinity_ring,
            shapName: "Infinity Ring",
            shapText: "Showcase your affection for your partner with a ring that symbolizes infinite love.",
            url: "/jewelry/wedding-rings-and-bands/style=Infinity%20Ring"
        },
        {
            shapImage: Pave_ring,
            shapName: "Pave Ring",
            shapText: "Enhance the sparkle of your ring with a centerpiece and lined-up diamonds.",
            url: "/jewelry/wedding-rings-and-bands/style=Pave"
        },
        {
            shapImage: Stackable_ring,
            shapName: "Stackable Ring",
            shapText: "Nest together multiple rings from our colossal collection.",
            url: "/jewelry/wedding-rings-and-bands/style=Stackable"
        },
    ]
    return (
        <>
            <div className='dfl_wedding_browsBy_style_section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={12} lg={12} className="p-0">
                            <div className='dfl_bgimg_ring_style'>
                                <Row>
                                    <Col sm={12} md={12} lg={8}>
                                        <div className='top_heading_metal pt-4'>
                                            <h2>Browse By Style</h2>
                                        </div>
                                        <div>
                                            <Slider {...browseBystyle} className="dfld_explore_diamond_shap_slider dfl_ring_style_slider">
                                                {ringStyle.map((val) => (
                                                    <NavLink to={val.url} className='dfld_img_shap_box_outer'>
                                                        <div className='dfld_img_shap_box_inner'>
                                                            <Image src={val.shapImage} alt={val.shapName} />
                                                            <h4>{val.shapName}</h4>
                                                            <p>{val.shapText}</p>
                                                        </div>
                                                    </NavLink>

                                                ))}
                                            </Slider>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default BrowseByStyle